import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSubscriptionAccess } from "../../Context/SubscriptionAccessContext";
import "./subscribe-required-modal.css";

const SubscribeRequiredModal = ({ forceOpen = false }) => {
  const { t } = useTranslation("common");
  const navigate = useNavigate();
  const { showSubscribeModal, dismissSubscribeModal } = useSubscriptionAccess();
  const open = forceOpen || showSubscribeModal;

  if (!open) return null;

  const goSubscribe = () => {
    dismissSubscribeModal();
    navigate("/subscription");
  };

  return (
    <div className="subscribe-required-overlay" role="dialog" aria-modal="true">
      <div className="subscribe-required-modal">
        <h2>{t("Subscription required")}</h2>
        <p>
          {t("You need to purchase a subscription before you can use this application.")}
        </p>
        <div className="subscribe-required-actions">
          <button type="button" className="btn btn-ghost" onClick={dismissSubscribeModal}>
            {t("Close")}
          </button>
          <button type="button" className="btn btn-primary" onClick={goSubscribe}>
            {t("Subscribe Now")}
          </button>
        </div>
      </div>
    </div>
  );
};

SubscribeRequiredModal.propTypes = {
  forceOpen: PropTypes.bool
};

SubscribeRequiredModal.defaultProps = {
  forceOpen: false
};

export default SubscribeRequiredModal;
